import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7310247c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed left-0 top-0 z-50 w-full h-full grid content-center bg-black/50 transition-opacity"
}
const _hoisted_2 = { class: "text-2xl font-semibold text-success uppercase my-5 text-center" }
const _hoisted_3 = { class: "flex flex-col gap-2 p-5" }
const _hoisted_4 = { class: "grid mt-3 p-5" }

import { watch, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
  title: {
    type: String,
    required: false,
  },
  visible: {
    type: Boolean,
    default: false,
    required: false,
  },
  background: {
    type: String,
    required: false,
    default: "bg-white",
  },
},
  emits: ["update:visible", "onClose"],
  setup(__props, { emit }) {

const props = __props;





const openingModal = ref(false);

const clickOutside = () => {
  if (!openingModal.value) {
    close();
  }
};

const close = () => {
  emit("update:visible", false); // Cierra el modal
  emit("onClose"); // Lanza evento opcional si el padre quiere hacer algo extra
};

watch(props, () => {
  if (!props.visible) {
    emit("onClose");
  } else {
    openingModal.value = true;
    setTimeout(() => {
      openingModal.value = false;
    }, 500);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (__props.visible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([__props.background, "md:w-xl md:shadow-lg md:rounded-lg m-auto p-6 relative transition-all w-5/6 modal-container max-h-[100%] overflow-y-auto"]),
                id: "dialog"
              }, [
                _createVNode(_component_mdicon, {
                  class: "absolute right-5 top-5 text-black cursor-pointer z-[9999]",
                  name: "close",
                  onClick: close
                }),
                _renderSlot(_ctx.$slots, "header", {}, () => [
                  _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1)
                ]),
                _createElementVNode("section", _hoisted_3, [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _createElementVNode("footer", _hoisted_4, [
                  _renderSlot(_ctx.$slots, "footer")
                ])
              ], 2)), [
                [_directive_click_outside, clickOutside]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})